const siteUrl = process.env.ENVIRONMENT ? process.env.SITE_URL : 'http://localhost:8000'
export default siteUrl